import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setCoachesArray, setGlobalInfo, setLocalInfo, AsyncAllInfos, filterSearch } from './statistics.action';

import { InfoCard } from '../../components/index';
import SearchFilter from '../../components/search-filter/search-filter'
import { Card, Icon, Table } from 'antd';
import TableColumns from '../../../utils/table-coaches-columns';
import moment from 'moment';

import './statistics.css';
import { STATUS } from '../../../utils/constants';

class Statistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: []
    }

    this.updateData = this.updateData.bind(this)
    this.generateCsv = this.generateCsv.bind(this)
  }

  componentDidMount() {
    this.props.AsyncAllInfos();
    this.setState({
      dataSource: this.props.statistics.coachesInfoArray
    })
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statistics.coachesInfoArray) {
      this.setState({ dataSource: nextProps.statistics.coachesInfoArray })
    }
  }

  generateCsv() {
    const arrayInfo = this.state.dataSource.map(a => ({
      ...a,
      last_login: a.last_login ? moment(a.last_login).format('DD/MM/YYYY HH:mm') : '',
      last_session: a.last_session ? moment(a.last_session).format('DD/MM/YYYY HH:mm') : '',
      status: STATUS[a.status]
    }))

    let keys = ['name', 'email', 'total_coachees', 'coupon', 'classname', 'last_login', 'sessions', 'complete_cycles', 'total_coaching_hours', 'status', 'last_session']
    let array = [['Nome', 'Email', 'Coachees', 'Cupom', 'Turma', 'Último acesso', 'Sessões realizadas', 'Ciclos finalizados', 'Horas coaching', 'Status', 'Última Sessão']]

    for (let item of arrayInfo) {
      let arrayAux = []
      for (let key of keys) {
        arrayAux.push(item[key])
      }
      array.push(arrayAux)
    }

    let csv = '';
    array.forEach((row) => {
      csv += row.join(';');
      csv += "\n";
    });

    let hiddenElement = document.createElement('a');
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
    hiddenElement.target = '_blank';
    hiddenElement.download = 'tabela.csv';
    hiddenElement.click();
  }


  updateData(array = this.props.statistics.coachesInfoArray) {
    this.setState({ dataSource: array })
  }
  render() {
    const paths = [{ icon: 'home' }, { icon: 'line-chart', text: 'Estatísticas' }];
    let { globalStatus, localStatus, coachesInfoArray, syncronizing, searchInput } = this.props.statistics;

    let local_total_horas = localStatus.total_horas ? parseFloat(localStatus.total_horas).toFixed(0) : undefined;
    let global_total_horas = globalStatus.total_hours ? parseFloat(globalStatus.total_hours).toFixed(0) : undefined;

    return (
      <div className='statistics-container'>
        <section className='stats'>
          <Card title={`Estatísticas de Coaching Local`}>
            <section className='info-wrapper'>
              <InfoCard className='license' value={localStatus.num_coaches} sync={syncronizing} name={'Total de Coaches'} />
              <InfoCard className='license' value={localStatus.total_ativos} sync={syncronizing} name={'Coaches Ativos'} />
              <InfoCard className='license' value={localStatus.subscriptions} sync={syncronizing} name={'Assinaturas'} />
              <InfoCard className='license' value={localStatus.comissions} sync={syncronizing} name={'Comissão'} />
              <InfoCard className='license' value={localStatus.num_coachees} sync={syncronizing} name={'Total de Coachees'} />
              <InfoCard className='license' value={localStatus.num_sessoes} sync={syncronizing} name={'Número de Sessões'} />
              <InfoCard className='license' value={localStatus.num_ciclos_completos} sync={syncronizing} name={'Ciclos Completados'} />
              <InfoCard className='license' value={local_total_horas} sync={syncronizing} name={'Total de Horas'} />
            </section>
          </Card>

          <Card title='Estatísticas de Coaching Global'>
            <section className='info-wrapper'>
              <InfoCard className='coaching' value={globalStatus.total_coachees} sync={syncronizing} name={'Coachees'} />
              <InfoCard className='coaching' value={globalStatus.total_sessions} sync={syncronizing} name={'Sessões Realizadas'} />
              <InfoCard className='coaching' value={globalStatus.total_complete_cycles} sync={syncronizing} name={'Ciclos Finalizados'} />
              <InfoCard className='coaching' value={global_total_horas} sync={syncronizing} name={'Horas de Coaching'} />
            </section>
          </Card>
        </section>

        <button onClick={() => this.props.AsyncAllInfos(true)} className='refresh-button' title='Atualizar Dados'>
          <Icon type='sync' spin={syncronizing} />
        </button>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  statistics: state.statistics
});

const mapDispatchToProps = dispatch => bindActionCreators({ setCoachesArray, setGlobalInfo, setLocalInfo, AsyncAllInfos, filterSearch }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Statistics);



// WEBPACK FOOTER //
// ./src/App/containers/statistics/statistics.js